<template>
  <div class="main_Container">

  <section class="p-4">
    <div class="container-fluid">
      <div v-show="this.isloading" class="data__loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="card" v-show="!this.isloading">
        <div class="card-body">
          <div class="card-body__form">
            <form @submit.prevent="updateContactUs">
              <div class="row">
                <!-- Facebook -->
                <div class="col-lg-6">
                  <div class="form-group">
                    <label for="facebookLink">فيسبوك</label>
                    <input
                      type="text"
                      id="facebookLink"
                      class="form-control"
                      placeholder="Facebook Url"
                      v-model="contactUs.facebook"
                    />
                  </div>
                </div>
                <!-- Youtube -->
                <div class="col-lg-6">
                  <div class="form-group">
                    <label for="youtubeLink">يوتيوب</label>
                    <input
                      type="text"
                      id="youtubeLink"
                      class="form-control"
                      placeholder="Youtube Url"
                      v-model="contactUs.youtube"
                    />
                  </div>
                </div>
                <!-- Twitter -->
                <div class="col-lg-6">
                  <div class="form-group">
                    <label for="TwitterLink">تويتر</label>
                    <input
                      type="text"
                      id="TwitterLink"
                      class="form-control"
                      placeholder="Twitter"
                      v-model="contactUs.twitter"
                    />
                  </div>
                </div>
                <!-- Telegram -->
                <div class="col-lg-6">
                  <div class="form-group">
                    <label for="TelegramLink">تيليجرام</label>
                    <input
                      type="text"
                      id="TelegramLink"
                      class="form-control"
                      placeholder="Telegram"
                      v-model="contactUs.telegram"
                    />
                  </div>
                </div>
                <!-- Phone -->
                <div class="col-lg-6">
                  <div class="form-group">
                    <button
                      class="btn add w-100"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#addNewPhoneModal"
                    >
                      <i class="fas fa-plus ms-1"></i>
                      اضافة رقم جديد
                    </button>
                    <!-- Add New Phone Modal Start -->
                    <div
                      class="modal fade"
                      id="addNewPhoneModal"
                      tabindex="-1"
                      aria-labelledby="addNewPhoneModalLabel"
                      aria-hidden="true"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">اضافة رقم جديد</h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              @click="clearData()"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <form @submit.prevent="addNewNumber($event)">
                              <div class="form-group">
                                <label for="phoneNumber">رقم الهاتف</label>
                                <input
                                  type="text"
                                  class="form-control mt-2"
                                  placeholder="رقم الهاتف"
                                  id="phoneNumber"
                                  v-model="addPhone.phone"
                                  required
                                />
                              </div>
                              <div class="form-group">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :value="true"
                                    v-model="addPhone.whatsapp"
                                    id="haveWhatsApp"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="haveWhatsApp"
                                  >
                                    هذا الرقم يمتلك واتساب
                                  </label>
                                </div>
                              </div>
                              <div class="form-group text-start mt-4">
                                <button type="submit" class="btn add w-100">
                                  أضافة
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Add New Phone Modal End -->
                  </div>
                </div>
                <!-- Address -->
                <div class="col-lg-6">
                  <div class="form-group">
                    <button
                      class="btn add w-100"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#addNewAddressModal"
                    >
                      <i class="fas fa-plus ms-1"></i>
                      اضافة عنوان جديد
                    </button>
                    <!-- Add New Address Modal Start -->
                    <div
                      class="modal fade"
                      id="addNewAddressModal"
                      tabindex="-1"
                      aria-labelledby="addNewAddressModalLabel"
                      aria-hidden="true"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">اضافة عنوان جديد</h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              @click="clearData()"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <form @submit.prevent="addNewAddress($event)">
                              <div class="form-group">
                                <label for="addressTitle">العنوان</label>
                                <input
                                  type="text"
                                  class="form-control mt-2"
                                  placeholder="العنوان"
                                  id="addressTitle"
                                  v-model="addAddress.title"
                                  required
                                />
                              </div>
                              <div class="form-group">
                                <label for="addressLatitude">خط العرض</label>
                                <input
                                  type="text"
                                  class="form-control mt-2"
                                  placeholder="Latitude"
                                  id="addressLatitude"
                                  v-model="addAddress.latitude"
                                />
                              </div>
                              <div class="form-group">
                                <label for="addressLongitude">خط الطول</label>
                                <input
                                  type="text"
                                  class="form-control mt-2"
                                  placeholder="Longitude"
                                  id="addressLongitude"
                                  v-model="addAddress.longitude"
                                />
                              </div>
                              <div class="form-group text-start mt-4">
                                <button type="submit" class="btn add w-100">
                                  أضافة
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Add New Address Modal End -->
                  </div>
                </div>
                <!-- Phones Table -->
                <div class="col-lg-6">
                  <div
                    class="table-responsive"
                    v-if="this.contactUs.phone_numbers.length > 0"
                  >
                    <table
                      class="
                        table table-bordered
                        sub_table
                        styled-table
                        small-table
                        table-striped
                      "
                    >
                      <thead>
                        <tr>
                          <th class="fit" scope="col">الرقم</th>
                          <th scope="col">الرقم التليفون</th>
                          <th scope="col">لديه واتساب</th>
                          <th scope="col">التحكم</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(phone, index) in this.contactUs.phone_numbers"
                          :key="index"
                        >
                          <td class="text-center">{{ index + 1 }}</td>
                          <td>{{ phone.phone }}</td>
                          <td class="text-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              :checked="phone.whatsapp"
                              id="flexCheckChecked"
                              disabled
                            />
                          </td>
                          <td style="width: 20%" class="controls">
                            <button
                              class="btn edit icon"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#EditPhoneModal"
                              @click="getPhone(index)"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <!-- Edit Phone Modal Start -->
                            <div
                              class="modal fade"
                              id="EditPhoneModal"
                              tabindex="-1"
                              aria-labelledby="EditPhoneModalLabel"
                              aria-hidden="true"
                              data-bs-backdrop="static"
                              data-bs-keyboard="false"
                            >
                              <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title">تعديل الرقم</h5>
                                    <button
                                      type="button"
                                      class="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                      @click="clearData()"
                                    ></button>
                                  </div>
                                  <div class="modal-body">
                                    <form
                                      @submit.prevent="
                                        EditSelectedPhone(index, $event)
                                      "
                                    >
                                      <div class="form-group">
                                        <label for="phoneNumber"
                                          >رقم الهاتف</label
                                        >
                                        <input
                                          type="text"
                                          class="form-control mt-2"
                                          placeholder="رقم الهاتف"
                                          id="phoneNumber"
                                          v-model="addPhone.phone"
                                          required
                                        />
                                      </div>
                                      <div class="form-group">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="true"
                                            v-model="addPhone.whatsapp"
                                            id="haveWhatsApp"
                                          />
                                          <label
                                            class="form-check-label"
                                            for="haveWhatsApp"
                                          >
                                            هذا الرقم يمتلك واتساب
                                          </label>
                                        </div>
                                      </div>
                                      <div class="form-group text-start mt-4">
                                        <button
                                          type="submit"
                                          class="btn edit w-100"
                                        >
                                          تعديل
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Edit Phone Modal End -->
                            <button
                              class="btn delete icon"
                              @click="deleteNumber(index)"
                              type="button"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="no_data" v-else>
                    <div class="no_data_text text-center">
                      لا يوجد ارقام لعرضها
                    </div>
                  </div>
                </div>
                <!-- Address Table -->
                <div class="col-lg-6">
                  <div
                    class="table-responsive"
                    v-if="this.contactUs.address.length > 0"
                  >
                    <table
                      class="
                        table table-bordered
                        sub_table
                        styled-table
                        small-table
                        table-striped
                      "
                    >
                      <thead>
                        <tr>
                          <th class="fit" scope="col">الرقم</th>
                          <th scope="col">العنوان</th>
                          <th scope="col">خط العرض</th>
                          <th scope="col">خط الطول</th>
                          <th scope="col">التحكم</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(address, index) in this.contactUs.address"
                          :key="index"
                        >
                          <td class="text-center">{{ index + 1 }}</td>
                          <td>{{ address.title }}</td>
                          <td>
                            <span v-if="address.latitude">{{
                              address.latitude
                            }}</span>
                            <span v-else>لم يتم ادخاله</span>
                          </td>
                          <td>
                            <span v-if="address.longitude">{{
                              address.longitude
                            }}</span>
                            <span v-else>لم يتم ادخاله</span>
                          </td>
                          <td style="width: 20%" class="controls">
                            <button
                              class="btn edit icon"
                              @click="getAddress(index)"
                              data-bs-toggle="modal"
                              data-bs-target="#EditAddressModal"
                              type="button"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <!-- Add New Phone Modal Start -->
                            <div
                              class="modal fade"
                              id="EditAddressModal"
                              tabindex="-1"
                              aria-labelledby="EditAddressModalLabel"
                              aria-hidden="true"
                              data-bs-backdrop="static"
                              data-bs-keyboard="false"
                            >
                              <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title">تعديل العنوان</h5>
                                    <button
                                      type="button"
                                      class="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                      @click="clearData()"
                                    ></button>
                                  </div>
                                  <div class="modal-body">
                                    <form
                                      @submit.prevent="
                                        EditSelectedAddress(index, $event)
                                      "
                                    >
                                      <div class="form-group">
                                        <label for="addressTitle"
                                          >العنوان</label
                                        >

                                        <input
                                          type="text"
                                          class="form-control mt-2"
                                          placeholder="العنوان"
                                          id="addressTitle"
                                          v-model="addAddress.title"
                                          required
                                        />
                                      </div>
                                      <div class="form-group">
                                        <label for="addressLatitude"
                                          >خط العرض</label
                                        >
                                        <input
                                          type="text"
                                          class="form-control mt-2"
                                          placeholder="Latitude"
                                          id="addressLatitude"
                                          v-model="addAddress.latitude"
                                        />
                                      </div>
                                      <div class="form-group">
                                        <label for="addressLongitude"
                                          >خط الطول</label
                                        >
                                        <input
                                          type="text"
                                          class="form-control mt-2"
                                          placeholder="Longitude"
                                          id="addressLongitude"
                                          v-model="addAddress.longitude"
                                        />
                                      </div>
                                      <div class="form-group text-start mt-4">
                                        <button
                                          type="submit"
                                          class="btn edit w-100"
                                        >
                                          تعديل
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Add New Phone Modal End -->
                            <button
                              class="btn delete icon"
                              @click="deleteAddress(index)"
                              type="button"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="no_data" v-else>
                    <div class="no_data_text text-center">
                      لا يوجد عناوين لعرضها
                    </div>
                  </div>
                </div>
                <!-- Submit -->
                <div class="text-start mt-4">
                  <button class="btn btn-primary" type="submit">حفظ</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
export default {
  data() {
    return {
      isloading: true,
      firstLoad: true,
      contactUs: {
        contactus_id: "",
        facebook: "",
        youtube: "",
        twitter: "",
        telegram: "",
        phone_numbers: [],
        address: [],
      },
      addPhone: {
        phone: "",
        whatsapp: false,
      },
      addAddress: {
        title: "",
        latitude: "",
        longitude: "",
      },
    };
  },
  methods: {
    // Vuex
    ...mapActions("contactusModule", ["fetchContactus", "updateContact"]),
    //
    async addNewNumber(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      this.contactUs.phone_numbers.push(this.addPhone);
      closeButton.click();
    },
    async addNewAddress(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.contactUs.address.push(this.addAddress);
      closeButton.click();
    },
    async updateContactUs() {
      await this.updateContact(this.contactUs);
      this.clearAndShowSuccess();
    },
    // Edit
    getPhone(index) {
      this.addPhone = this.contactUs.phone_numbers[index];
    },
    getAddress(index) {
      this.addAddress = this.contactUs.address[index];
    },

    EditSelectedPhone(index, event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      this.contactUs.phone_numbers[index] = this.addPhone;
      closeButton.click();
    },

    EditSelectedAddress(index, event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      this.contactUs.address[index] = this.addAddress;
      closeButton.click();
    },

    ///// Delete
    async deleteNumber(index) {
      Swal.fire({
        text: "هل أنت متأكد من حذف رقم التليفون؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.contactUs.phone_numbers.splice(index, 1);
        }
      });
    },

    async deleteAddress(index) {
      Swal.fire({
        text: "هل أنت متأكد من حذف العنوان؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.contactUs.address.splice(index, 1);
        }
      });
    },
    //

    //---------------------------//
    // Handle Add Code
    clearAndShowSuccess() {
      this.seccussAdd();
      this.clearData();
    },
    // clear Data when close modal
    clearData() {
      this.addPhone = {
        phone: "",
        whatsapp: false,
      };
      this.addAddress = {
        title: "",
        latitude: "",
        longitude: "",
      };
    },

    // On Upload Image
    seccussAdd() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم الاضافة بنجاح",
      });
    },
  },
  async created() {
    if (this.isFirstLoad) await this.fetchContactus();
  },
  computed: {
    ...mapGetters("contactusModule", [
      "getContactus",
      "isLoading",
      "isFirstLoad",
    ]),
  },
  mounted() {
    this.firstLoad = this.isFirstLoad;
    this.isloading = this.isLoading;
    this.contactUs = this.getContactus;
  },
  watch: {
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    getContactus() {
      this.contactUs = this.getContactus;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 1rem;
}
</style>